var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading
        ? [
            _vm.localInvoices.length
              ? [
                  _c("InvoicesTableList", {
                    attrs: {
                      invoices: _vm.localInvoices,
                      paginator: _vm.paginator,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _vm.paginator
                        ? _c("paginate", {
                            attrs: {
                              "page-count": _vm.paginator.last_page,
                              "page-range": 8,
                              "margin-pages": 2,
                              "click-handler": _vm.getInvoices,
                              "prev-text": "&laquo",
                              "next-text": "&raquo",
                              "container-class": "pagination",
                              "prev-class": "page-item",
                              "prev-link-class": "page-link",
                              "page-class": "page-item",
                              "page-link-class": "page-link",
                              "next-class": "page-item",
                              "next-link-class": "page-link",
                              "active-class": "active green_btn",
                            },
                            model: {
                              value: _vm.paginator.current_page,
                              callback: function ($$v) {
                                _vm.$set(_vm.paginator, "current_page", $$v)
                              },
                              expression: "paginator.current_page",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : [
                  _c("h5", { staticClass: "text-center" }, [
                    _vm._v("Накладные не найдены"),
                  ]),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }